module.exports = __webpack_public_path__ + "static/media/snow_fall.f5524c07.png";